module.exports = __webpack_public_path__ + "static/media/googlelog129.7f2bc36f.PNG";